import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingCentum2Pc from './designcomponents/sunbaebriefingcentum2pc';
import SunbaeBriefingCentum2Mobile from './designcomponents/sunbaebriefingcentum2mobile';

export default function SunbaeBriefingCentum2() {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile ? <SunbaeBriefingCentum2Mobile /> : <SunbaeBriefingCentum2Pc />;
}
